import React, { Component } from 'react'
import { MensagemModel, OrientacaoModel, RemetenteMensagem } from '../Store/Chat'
import styled from 'styled-components';
import { format } from 'date-fns';
import { apiState } from '../Api';

interface IChatProps {
  mensagens: MensagemModel[];
  carregarMais: () => void;
  carregando?: apiState;
  doDownload: (id: string) => void;
  usuario: RemetenteMensagem;
  orientacao?: OrientacaoModel;
}

const StyledMensagemDaDireita = styled.div`
  position: relative;
  background-color: ${props => props.theme.secondaryDarkColor};
  color: white;
  padding: 6px;
  margin-right: 5px;
  border-radius: 4px;
  word-wrap: break-word;
  overflow: hidden;

  &::before{
    position: absolute;
    right: -7px
    top: -1px;
    content: '';
    width: 0; 
    height: 0; 
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent; 
    
    border-left:10px solid ${props => props.theme.secondaryDarkColor}; 
  }
`;

const StyledMensagemDaEsquerda = styled.div`
  position: relative;
  background-color: ${props => props.theme.primaryColor};
  color: white;
  padding: 6px;
  margin-left: 5px;
  border-radius: 4px;
  word-wrap: break-word;
  overflow: hidden;

  &::before{
    position: absolute;
    left: -7px
    top: -1px;
    content: '';
    width: 0; 
    height: 0; 
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent; 
    
    border-right:10px solid ${props => props.theme.primaryColor}; 
  }
`;

const StyledMessageContainerDireita = styled.div`
  position: relative;
  max-width: 55%;
  margin-bottom: 5px;
  
`

const StyledMessageContainerEsquerda = styled.div`
  position: relative;
  max-width: 55%;
  margin-bottom: 5px;
  float: left;
`

const StyledMessageContainer = styled.div`
  position: relative;
  margin-bottom: 5px;
  width: 50%;
  min-width: 150px;
  display: flex;
  flex-direction: column;
`

const StyledMessageLock = styled.div`
  position: relative;
  height: fit-content;
  display: flex;
`

const StyledMessagesContainer = styled.div`
  position: relative;
  width: 100%;
  height:350px;
  display: flex;
  flex-direction: column-reverse;

  overflow-y: auto;
  overflow-x: hidden;
`

const StyledCenteredMessage = styled.div`
  
  border-radius: 4px;
  padding: 5px;
  background-color: ${(props) => props.theme.greyColor};
  margin-bottom: 5px;
`

const StyledSpan = styled.span`
  font-size: 0.9em;
`

const StyledAnexo = styled.div`
  width: calc(100% + 10px);
  margin-left: -10px;
  margin-bottom: -5px;
  padding: 4px 6px 4px 4px;
  border-top: 2px solid rgba(255,255,255,0.5);
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    backdrop-filter: brightness(50%);
    cursor: pointer;
  }  
`;

export default class Chat extends Component<IChatProps> {

  constructor(args: any) {
    super(args);

  }


  onScrollEvent = (e: any) => {
    if (e.target.scrollTop === 0 && ![apiState.noContent, apiState.loading].includes(this.props.carregando || apiState.done)) {
      this.props.carregarMais();
    }
  }


  render() {
    const {
      usuario,
      mensagens,
      orientacao
    } = this.props;

    return (
      <StyledMessagesContainer
        onScroll={this.onScrollEvent}
      >
        {mensagens
          .map(m => {
            if (m.registroDeReuniao) {
              return <StyledMessageLock style={{ justifyContent: 'center' }}>
                <StyledMessageContainer>
                  <StyledCenteredMessage dangerouslySetInnerHTML={{ __html: m.texto }} />
                  <StyledSpan style={{ float: 'left' }}>{"Enviada"} &#183; {format(m.modificadoEm, 'HH:mm DD/MM/YYYY')}</StyledSpan>
                </StyledMessageContainer>
              </StyledMessageLock>;
            } else if (m.escritoPor === usuario) { //Mensagem lado direito
              return <StyledMessageLock style={{ justifyContent: 'flex-end' }}>

                <StyledMessageContainerDireita>
                  <StyledMensagemDaDireita>
                    <p>{m.texto}</p>
                    {m.anexos.length > 0 &&
                      <StyledAnexo
                        onClick={() => this.props.doDownload(m.anexos[0].id)}
                      >
                        <img width="20px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAZElEQVRIie3VOw7AIAwDUKfq4bl1OyFRQI3NR2KIR5B5YQGgyKMlQY0I6EhuiYPwyCDAIxMAh0wCPrIAaBCriwBgZp/1HvC3X/Zvb1rvAA++RgAlAQQQQAAnAN3XlPkT2Gy/wQtsNQ/sqyL/qwAAAABJRU5ErkJggg==" />
                        {m.anexos[0].id}.{m.anexos[0].extensao}
                      </StyledAnexo>
                    }
                  </StyledMensagemDaDireita>
                  <StyledSpan style={{ float: 'right' }}>{m.lida ? "Visualizada" : "Enviada"} &#183; {format(m.modificadoEm, 'HH:mm DD/MM/YYYY')}</StyledSpan>
                </StyledMessageContainerDireita>
              </StyledMessageLock>;
            } else {
              return <StyledMessageLock>
                <StyledMessageContainerEsquerda>
                  <StyledMensagemDaEsquerda>
                    <p>{m.texto}</p>
                    {m.anexos.length > 0 &&
                      <StyledAnexo
                        onClick={() => this.props.doDownload(m.anexos[0].id)}
                      >
                        <img width="20px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAZElEQVRIie3VOw7AIAwDUKfq4bl1OyFRQI3NR2KIR5B5YQGgyKMlQY0I6EhuiYPwyCDAIxMAh0wCPrIAaBCriwBgZp/1HvC3X/Zvb1rvAA++RgAlAQQQQAAnAN3XlPkT2Gy/wQtsNQ/sqyL/qwAAAABJRU5ErkJggg==" />
                        {m.anexos[0].id}.{m.anexos[0].extensao.replace('application/', '')}
                      </StyledAnexo>
                    }
                  </StyledMensagemDaEsquerda>
                  <StyledSpan>Enviada &#183; {format(m.enviadoEm, 'HH:mm DD/MM/YYYY')}</StyledSpan>
                </StyledMessageContainerEsquerda>
              </StyledMessageLock>;
            }
          }
          )
        }
        {
          orientacao
          && orientacao.aluno
          && orientacao.aluno.monografia
          && this.props.carregando === apiState.noContent
          && <StyledMessageLock style={{ justifyContent: 'center' }}>
            <StyledMessageContainer>
              <StyledCenteredMessage>
                <h3>Informações da monografia</h3>
                <h4>Título</h4>
                <p>{orientacao.aluno.monografia.titulo}</p>
                <h4>Justificativa</h4>
                <p>{orientacao.aluno.monografia.justificativa}</p>
                <h4>Desenvolvimento</h4>
                <p>{orientacao.aluno.monografia.desenvolvimento}</p>
                <h4>Bibliografia</h4>
                <p>{orientacao.aluno.monografia.bibliografia}</p>
              </StyledCenteredMessage>
            </StyledMessageContainer>
          </StyledMessageLock>
        }
        {this.props.carregando === apiState.loading && <div style={{
          width: '100%',
          height: '30px',
          fontSize: '1.2em',
          margin: '10px',
          textAlign: 'center',
          color: 'grey'
        }}>Carregando novos registros...</div>}

        {this.props.carregando === apiState.noContent && <div style={{
          width: '100%',
          height: '30px',
          fontSize: '1.2em',
          margin: '10px',
          textAlign: 'center',
          color: 'grey'
        }}>Não existem mais registros</div>}
      </StyledMessagesContainer >
    )
  }
}
